export default "assets/images/icons/chevrons-7afd1b73.svg";